export default () => ({
  icon: {
    paddingRight: 10,
  },
});
